export interface IPagingInfo {
    pageSize: number;
    pageNumber: number;
    totalItemsCount: number;
}

export const initialPagingInfo: IPagingInfo = ({
    pageSize: 20,
    pageNumber: 0,
    totalItemsCount: null
});
